import React, {useState} from 'react';
import Card from "olive-react-myoneui/lib/Card";
import Tab from 'olive-react-myoneui/lib/Tab';
import Nav from 'olive-react-myoneui/lib/Nav';
import Form from 'olive-react-myoneui/lib/Form';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import Button from 'olive-react-myoneui/lib/Button';
import ProfileInfoEdit from './ProfileDetails';
import ProfilePasswordUpdate from './ProfilePasswordUpdate';
import ProfileHeader from './PofileHeader';
import { lockPadDot, homeIcon, userIcon } from '../../../constants/icons';
import { useSelector } from 'react-redux';
import AdditionalDetails from './AdditionalDetails';
import BreadCrumbs from '../BreadCrumbs';
import Error404 from '../../../../modules/Error404';
import { useNavigate } from 'react-router-dom';

function Settings({ className }) {
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);
  const configData = useSelector((state) => state.config);
  const paths         = useSelector((state) => state.user.paths);
  const learner       = configData.session;
  const additionalDetails = learner.us_profile_fields;
  const bannerImgPath = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/miscellaneous/profile-banner.webp';

  const addressObject = learner.us_address && ((learner.us_address !== '' && learner.us_address != 'null') || learner.us_address != null) ? JSON.parse(learner.us_address) : '';
  const address = addressObject && typeof addressObject === 'object' ? Object.values(addressObject).join(', ') : 'N/A';  
  
  const learnerProfileUrl = () => {
    navigate('/student-dashboard/learner-profile/');
  };
  
  const settingsPages = [
    { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
    { icon: userIcon, label: "Settings" }
  ];

  if (hasError) return <Error404 />;
  return (
    <>
    <BreadCrumbs pages={settingsPages} />
    <div className={`${className || ""} myk__stu-setting-container myk__stu-user-settings`}>
        <ProfileHeader
          className="mb-4"
          defaultProfileImg={paths.user_path + learner?.us_image}
          name={learner?.us_name}
          email={learner?.us_email}
          phone={`${learner?.us_country_code} ${learner?.us_phone}`}
          location={address}
          dropdownDownloadItems={false}
          dotDropdownItems={true}
          publicProfile={false}
          profileBannerImgUrl={bannerImgPath}
          viewProfileLink={learnerProfileUrl}
        />
      <div className="myk__stu-setting-body-wrapper">
        <Row>
          <Col xl="8">
            <Card className="border-0 bg-transparent">
              <Card.Body>
                <Tab.Container id="settings-tabs" defaultActiveKey="profile">
                  <Row>
                    <Col sm={12}>
                      <Nav variant="pills" className="mb-4 myk__stu-profile-tabs">
                        <Nav.Item>
                          <Nav.Link eventKey="profile">My details</Nav.Link>
                        </Nav.Item>
                        {additionalDetails && additionalDetails !== null &&
                        <Nav.Item>
                          <Nav.Link eventKey="additionalDetails">Additional Details</Nav.Link>
                        </Nav.Item>
                        }
                        <Nav.Item>
                          <Nav.Link eventKey="security">Password</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={12}>
                      <Tab.Content>
                        <Tab.Pane eventKey="profile">
                          <ProfileInfoEdit setHasError={setHasError} />
                        </Tab.Pane>
                        {additionalDetails && additionalDetails !== null &&
                        <Tab.Pane eventKey="additionalDetails" className='additional-blocks'>
                          <AdditionalDetails />
                        </Tab.Pane>
                        }
                        <Tab.Pane eventKey="security">
                          <Row>
                            <Col xl="8">
                              <ProfilePasswordUpdate />
                            </Col>
                            <Col xl="4">
                              <div className="myk__stu-password-tips">
                                <h3>
                                  <span className="pad-icon">{lockPadDot}</span>
                                  <span>Tips for Strong Password</span>
                                </h3>
                                <ul>
                                  <li>Add at least 8 characters</li>
                                  <li>Don't include your name or email address</li>
                                  <li>Don't use simple password like 123456 which can be guessed easily</li>
                                  <li>Include a number and special characters</li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  </>
  );
}

export default Settings;
